import React, { useState, useEffect } from 'react';

/**
 * SPLASH SCREEN / LOGO FADE-IN ANIMATION
 * 
 * Kullanım: Logo animasyonu için /public/images/splash.png veya splash.mp4 kullanılır
 * 
 * Nasıl değiştirilir:
 * 1. Kendi logo/video dosyanızı /public/images/ klasörüne koyun
 * 2. Aşağıdaki SPLASH_MEDIA değişkenini düzenleyin:
 *    - Resim için: "/images/splash.png" veya "/images/splash.jpg"
 *    - Video için: "/images/splash.mp4"
 * 3. ANIMATION_DURATION ile animasyon süresini ayarlayın (milisaniye)
 */

const SPLASH_MEDIA = "/images/logo.png"; // Burası değiştirilebilir
const ANIMATION_DURATION = 2500; // 2.5 saniye
const IS_VIDEO = SPLASH_MEDIA.endsWith('.mp4') || SPLASH_MEDIA.endsWith('.webm');

const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Fade out başlat
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, ANIMATION_DURATION - 500);

    // Animasyon tamamlandığında callback çağır
    const completeTimer = setTimeout(() => {
      setIsVisible(false);
      if (onComplete) onComplete();
    }, ANIMATION_DURATION);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div 
      className={`fixed inset-0 z-[100] bg-black flex items-center justify-center transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="relative">
        {IS_VIDEO ? (
          <video
            src={SPLASH_MEDIA}
            autoPlay
            muted
            playsInline
            className="max-w-md w-full h-auto animate-fade-in-scale"
          />
        ) : (
          <img
            src={SPLASH_MEDIA}
            alt="Corbaci Logo"
            className="max-w-md w-full h-auto animate-fade-in-scale"
          />
        )}
      </div>
    </div>
  );
};

export default SplashScreen;
